import { map, mergeDeepRight } from 'ramda'

const pages =
  [
    /* 授权认证回调页-新成功页面 */
    {
      path: '/auth-callback',
      name: 'h5-dy-auth-callback',
      component: () => import(/* webpackChunkName: "h5-dy-auth-callback" */ '@/views/h5/dy/auth-callback')
    }
  ] |> map(mergeDeepRight({ meta: { requireLogin: false, notShowDialog: true } }))

export default pages
